import { Evidence } from "@p0security/shared/types/evidence";
import { PermissionRequest } from "@p0security/shared/types/permission";
import {
  directories,
  resourceIntegrations,
} from "components/Integrations/constants";
import { compact } from "lodash";
import { FirestoreDoc } from "providers/FirestoreProvider";

import {
  requestDescription,
  requestLocator,
  toRequestDescription,
  toRequestLocation,
} from "../requestUtils";
import { FilterConfig } from "../types.ts";

/**
 * Filter config for active pre-approval page.
 * Computes integration map from context.flags when needed.
 */
export const PRE_APPROVAL_FILTER_CONFIG: FilterConfig<FirestoreDoc<Evidence>> =
  {
    getRequestor: (e) => e.data.principal,
    getApprover: (e) => e.data.approver?.email ?? e.data.approver?.name ?? null,
    getApproverSearchFields: (e) =>
      compact([e.data.approver?.name, e.data.approver?.email]),
    getResourceDescription: (e) => requestDescription(e.data),
    getLocation: (e, context) => {
      const location = requestLocator(e.data, context.integrations);
      if (location) return String(location);
      const integrationMap = [
        ...resourceIntegrations(context.flags),
        ...directories,
      ];
      return integrationMap.find((i) => i.key === e.data.type)?.label ?? null;
    },
    getRequestedTimestamp: (e) => e.data.createdAt,
  };

/**
 * Filter config for the active requests page.
 */
export const PERMISSION_REQUEST_FILTER_CONFIG: FilterConfig<
  FirestoreDoc<PermissionRequest>
> = {
  getRequestor: (r) => r.data.requestor,
  getApprover: (r) => {
    const { email, name, id, approvalSource } = r.data.approvalDetails || {};
    if (approvalSource === "evidence") return "Pre Approval";
    if (approvalSource === "persistent") return "By persistent access";
    return email || name || id || null;
  },
  getApproverSearchFields: (r) =>
    compact([r.data.approvalDetails?.name, r.data.approvalDetails?.email]),
  getResourceDescription: (r) => toRequestDescription(r.data),
  getLocation: (r, context) =>
    toRequestLocation(r.data, context.integrations, context.flags) ?? null,
  getRequestedTimestamp: (r) => r.data.requestedTimestamp,
  getApprovedTimestamp: (r) => r.data.approvalDetails?.approvedTimestamp,
};
